import * as React from 'react';
/**
 *
 * Original name: early bird
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=2916%3A1014
 *
 */
export const EarlyBirdLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M12.25 8.5a.696.696 0 0 0 .75-.75.75.75 0 1 0-1.5 0 .697.697 0 0 0 .75.75Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M16 11.5V9.25l1.5-.75-1.515-1.136C15.832 5.279 14.431 4 12.25 4 9.937 4 8.5 5.437 8.5 7.75v5.19L7.06 11.5H5V13c0 4.514 2.486 7 7 7 4.514 0 7-2.486 7-7v-1.5h-3Zm-3.75-6c1.493 0 2.25.757 2.25 2.25v3.75h-3.06L10 12.94V7.75c0-1.493.757-2.25 2.25-2.25Zm-.25 13c-3.629 0-5.48-1.83-5.5-5.439l2.75 2.75L12.06 13h5.44c0 3.65-1.85 5.5-5.5 5.5Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
